// src/stone/icons/Pix.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Pix = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M8.901 1.283a4.38 4.38 0 0 1 6.198 0l7.618 7.618a4.38 4.38 0 0 1 0 6.198l-7.618 7.618a4.38 4.38 0 0 1-6.198 0l-7.618-7.618a4.38 4.38 0 0 1 0-6.198zm4.783 1.415a2.38 2.38 0 0 0-3.368 0l-7.618 7.618c-.93.93-.93 2.438 0 3.368l7.618 7.618c.93.93 2.438.93 3.368 0l7.618-7.618c.93-.93.93-2.438 0-3.368z" }),
      /* @__PURE__ */ jsx("path", { d: "M5.4 5.5h1.292a3 3 0 0 1 2.1.857L11.3 8.815a1 1 0 0 0 1.4 0l2.509-2.458a3 3 0 0 1 2.099-.857H18.6v2h-1.292a1 1 0 0 0-.7.286L14.1 10.243a3 3 0 0 1-4.198 0L7.39 7.786l.617-.63-.616.63a1 1 0 0 0-.7-.286H5.4zm7.3 9.685a1 1 0 0 0-1.4 0l-2.509 2.458a3 3 0 0 1-2.1.857H5.4v-2h1.292a1 1 0 0 0 .7-.286L9.9 13.757a3 3 0 0 1 4.198 0l2.51 2.457a1 1 0 0 0 .699.286H18.6v2h-1.292a3 3 0 0 1-2.1-.857z" })
    ]
  }
);
var Pix_default = Pix;

export {
  Pix_default
};
